<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Automation Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.automationEntegration">Otomasyon Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.automationEventBase">Event Bazlı Otomasyon</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.automationWebhookBase">Webhook Bazlı Otomasyon</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.automationButtonBase">Button Bazlı Otomasyon</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.automationTimerBase">Timer Bazlı Otomasyon</a-checkbox>
                </div>
                <div class="feature-label">Otomasyon Oluşturma Limiti</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.automationLimit" />
                </div>
                <div class="feature-label">Free Task Limit per Month</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.automationTaskFreeLimit" />
                </div>
                <div class="feature-label">Task per Limit (Price Required!)</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.automationTaskPerLimit" />
                </div>
                <div class="feature-label">Task Limit per Price</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.automationTaskPerPrice" />
                </div>
                <div class="feature-label">Block Count</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.automationBlock" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "AutomationFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            automationEntegration: true,
            automationEventBase: false,
            automationWebhookBase: false,
            automationButtonBase: false,
            automationTimerBase: false,
            automationLimit: -1,
            automationBlock: 5,
            automationTaskFreeLimit: 0,
            automationTaskPerLimit: 0,
            automationTaskPerPrice: 0,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.AUTOMATION);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.AUTOMATION, ...this.featureForm };
                response[Features.AUTOMATION.LIMIT] = +v.automationLimit || 0;
                response[Features.AUTOMATION.BLOCK] = +v.automationBlock || 0;
                response[Features.AUTOMATION.TASK_FREE_LIMIT] = +v.automationTaskFreeLimit || 0;
                response[Features.AUTOMATION.TASK_LIMIT] = +v.automationTaskLimit || 0;
                response[Features.AUTOMATION.TASK_PER_LIMIT] = +v.automationTaskPerLimit || 0;
                response[Features.AUTOMATION.TASK_PER_PRICE] = +v.automationTaskPerPrice || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.AUTOMATION);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
